import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReservationsService } from 'src/app/services/reservations.service';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import * as moment from 'moment';
import { NotifierService } from 'angular-notifier';
import * as XLSX from "xlsx";
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EmployeeService } from 'src/app/services/employee.service';
import { AppAttributesService } from 'src/app/services/app-attributes.service';
import { Station } from 'src/app/models/station';
import { Contract } from 'src/app/models/contract';

@Component({
  selector: 'app-reservation-reports',
  templateUrl: './reservation-reports.component.html',
  styleUrls: ['./reservation-reports.component.scss']
})
export class ReservationReportsComponent implements OnInit {
  filters_form: FormGroup;
  private notifier: NotifierService;
  conciergeGreetData;
  searchText;
  stations;

  stationsList: Station[];
  AllStationsCodes = [];
  payrollReport = [];
  contracts: Contract[] = [];

  billingStatusList = [
    {
      resStatusId: "CP",
      resCustText: "Complete",
      resBoText: "Assigned"
    },
    {
      resStatusId: "CPNR",
      resCustText: "Completed Service",
      resBoText: "Needs Review"
    },
    {
      resStatusId: "UFSNR",
      resCustText: "Completed Service",
      resBoText: "Unfulfilled Service"
    }
  ];
  fromDate = moment().startOf("day").subtract(7, "days").format('MM/DD/YYYY HH:mm');
  toDate = moment().endOf("day").format('MM/DD/YYYY HH:mm');
  reservationStatusList = [
    {
      resStatusId: "R",
      resCustText: "Canceled without Charges",
      resBoText: "Canx No Charge"
    },
    {
      resStatusId: "X",
      resCustText: "Canceled with Charges",
      resBoText: "Canx Charge"
    }
  ];
  yesNoOptions = [
    { label: 'Capital one', value: true },
  ];
  constructor(private spinner: NgxSpinnerService, private formBuilder: FormBuilder, notifier: NotifierService,
              private reservationService: ReservationsService,
              private authService: AuthenticationService,
              private employeeService: EmployeeService,
              private appAttrService: AppAttributesService
  ) {
    this.initForm();
  }

  ngOnInit() {
    this.getData();
    this.getAppAttributes();
  }

  getAppAttributes() {
    this.contracts = this.appAttrService.getContractsWithRetail();
    // console.log(this.appAttrService.getContractsWithRetail());

    this.stations = this.appAttrService.getAppAttributes().stations;
  }
  // START---Initial Loading
  getData() {
    if (this.authService.isStationAdmin()) {
      this.getDetailsByStations()
    } else {
      this.getDetails();
    }
  }
  getDetails() {
    this.spinner.show();
    let data = {
      from: moment(this.fromDate).startOf("day").format('MM/DD/YYYY HH:mm'),
      to: moment(this.toDate).endOf("day").format('MM/DD/YYYY HH:mm'),
      resStatusId: ["X", "R"],
    }
    this.reservationService.getConciergeReport(data).subscribe(res => {
      this.conciergeGreetData = res['result'];
      setTimeout(() => { this.spinner.hide(); }, 1000);
    });
  }
  getDetailsByStations() {
    this.AllStationsCodes = [];
    this.spinner.show()
    this.employeeService.getEmployeeById(this.authService.getCurrentUserId()).subscribe(res => {
      this.stationsList = res['result']['stations']

      res['result']['stations'].forEach(station => {
        this.AllStationsCodes.push(station.stationid);
      });

      let data = {
        stations: this.AllStationsCodes,
        from: moment(this.fromDate).startOf("day").format('MM/DD/YYYY HH:mm'),
        to: moment(this.toDate).endOf("day").format('MM/DD/YYYY HH:mm'),
      }
      this.reservationService.getConciergeReportForStationManager(data).subscribe(res => {
        this.conciergeGreetData = res['result'];
        setTimeout(() => { this.spinner.hide(); }, 1000);
      });
    });
  }

  // END---Initial Loading

  getDate(date) {
    if(!date) return '';
    return moment.utc(date).format('MMM DD, YYYY');
  }
  getTime(date) {
    return moment.utc(date).format("MMM DD, YYYY HH:mm");
  }
  initForm() {
    this.filters_form = this.formBuilder.group({
      resType: new FormControl(''),
      stationcodes: new FormControl(''),
      resStatus: new FormControl(''),
      startdate: new FormControl(this.fromDate),
      enddate: new FormControl(this.toDate),
      isCapitalOne: new FormControl([])
    })
  }

  onFilter(values) {
    if (values.startdate == '' && values.enddate == '') {
      this.notifier.notify('warning', 'Please enter date');
      return;
    }
    if (values.startdatee == '' || values.startdate == null || values.startdate == 'Invalid date') {
      this.notifier.notify('warning', 'Please enter from date');
      return;
    }
    if (values.enddate == '' || values.enddate == null || values.enddate == 'Invalid date') {
      values.enddate = moment().format("MM/DD/YYYY HH:mm")
    }
    if (moment(values.startdate).isAfter(moment(values.enddate))) {
      this.notifier.notify('warning', 'From date must be less then to date');
      return;
    }
    let resStatusId = ['X', 'R'];
    if(values.resStatus.length > 0) {
      resStatusId = values.resStatus
    }
    this.spinner.show();
    let data = {
      stations: values.stationcodes,
      from: moment(values.startdate).startOf("day").format('MM/DD/YYYY HH:mm'),
      to: moment(values.enddate).endOf("day").format('MM/DD/YYYY HH:mm'),
      resType: values.resType,
      resStatus: resStatusId,
      isCapitalOne: values.isCapitalOne
    }
    this.reservationService.getConciergeReportByFilter(data).subscribe(res => {
      this.conciergeGreetData = res['result'];
      setTimeout(() => { this.spinner.hide(); }, 1000);
    });
  }

  isShow: boolean = false;
  showFilter() {
    this.isShow = !this.isShow;
  }
  onReset() {
    this.initForm();
    this.isShow = false
    this.searchText = ''
    this.getData();
  }

  exportExcel() {

    this.payrollReport = this.conciergeGreetData.map(
        x => ({
          "Res ID": x.resId,
          "Promotional Contract": x.is_capital_one ? 'Capital One': '',
          "Retail ResID": x.linkedResId,
          "Res Type": x.res_Type,
          "Station": x.AirportIATA,
          "Employee ID": x.emp_id,
          "Primary Concierge": x.firstname + " " + x.lastname,
          "Secondary Concierge": x.SecondaryAgent,
          "RES Status": x.RES_STATUS,
          "Cancellation email": x.cancelled_email,
          "Canceled by API": x.cancelled_email ? '' : 'API',
          "Cancellation date": this.getTime(x.cancelled_last_change_ddt_utc),
          "Primary Concierge Status": x.GREET_SERVICE_AGENT_STATUS == 'CP' ? 'Complete' : x.GREET_SERVICE_AGENT_STATUS == 'UFSNR' ? 'Unfulfilled Service' : x.GREET_SERVICE_AGENT_STATUS == 'CPNR' ? 'Needs Review' : '',
          "Billing Status": x.GREET_SERVICE_BACKOFFICE_STATUS,
          "Direction": x.ServiceDirectionID == 'D' ? 'Departure' : x.ServiceDirectionID == 'A' ? 'Arrival' : 'Transfer',
          "Greet Date": x.StartDT,
          "Greet Start": x.greetStartTime,
          "Greet End": x.greetEndTime,
          "Worked Hours": x.workedHours,
          "Secondary Concierge Greet Start": x.SecondaryGreetStartTime,
          "Secondary Concierge Greet End": x.SecondaryGreetEndTime,
          "Secondary Worked Hours": x.SecondaryWorkedHours,
          "Notes": x.notes,
          "Credit Service Failure": x.CREDIT_SERVICE_FAILURE,
          "Credit Service Failure Reason": x.CREDIT_SERVICE_FAILURE_REASON,
          "Credit Service Failure Notes": x.CREDIT_SERVICE_FAILURE_NOTES,
          "Credit Service Amount": x.CREDIT_SERVICE_AMOUNT,
          "Physcical Contact": x.PHYSICAL_CONTACT,
          "Client Happy": x.CLIENT_HAPPY,
          "Additional Labour Hours": x.ADDITIONAL_LABOUR_HOURS,
          "Carts": x.CARTS,
          "Bags": x.BAGS,
          "Service Tip Amount": x.SERVICE_TIP_AMOUNT
        })
    )

    const workSheet = XLSX.utils.json_to_sheet(this.payrollReport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, 'canceledReservationsReport');
    let timeSpan = new Date().toISOString();
    let prefix = "canceledReservationsReport";
    let fileName = `${prefix}-${timeSpan}.xlsx`;
    XLSX.writeFile(workBook, fileName);
  }

  exportToExcel() {
    TableUtil.exportToExcel("report25con");
  }

}





export class TableUtil {
  static exportToExcel(tableId: string, name?: string) {
    let timeSpan = new Date().toISOString();
    let prefix = name || "ExportResult";
    let fileName = `${prefix}-${timeSpan}`;
    let targetTableElm = document.getElementById(tableId);
    let wb = XLSX.utils.table_to_book(targetTableElm, <XLSX.Table2SheetOpts>{ sheet: prefix });
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }
}

